/**
 * Parses <thinking>, <response>, <action>, <suggestions>, <rate> XML tags out of AI message text.
 * Returns an array of { type: 'thinking'|'response'|'action'|'suggestions'|'rate'|'text', content }.
 *
 * @param {string} text
 * @param {boolean} isPartial - true while streaming (closing tag may not have arrived)
 * @returns {{ type: string, content: string }[]}
 */

const TAG_RE =
  /<(thinking|response|action|suggestions|rate)>([\s\S]*?)<\/\1>/gi;
const PARTIAL_TAG_RE =
  /<(thinking|response|action|suggestions|rate)>([\s\S]*)$/i;
const OPENING_TAG_IN_PROGRESS_RE = /^<[a-zA-Z_]*$/;

export function parseTaggedContent(text, isPartial = false) {
  if (!text) return [{ type: 'text', content: '' }];

  const segments = [];
  let lastIndex = 0;
  let match;
  const re = new RegExp(TAG_RE.source, 'gi');

  // eslint-disable-next-line no-cond-assign
  while ((match = re.exec(text)) !== null) {
    const before = text.slice(lastIndex, match.index).trim();
    if (before) segments.push({ type: 'text', content: before });
    segments.push({ type: match[1].toLowerCase(), content: match[2].trim() });
    lastIndex = match.index + match[0].length;
  }

  const tail = text.slice(lastIndex);

  if (isPartial) {
    const partialMatch = PARTIAL_TAG_RE.exec(tail);
    if (partialMatch) {
      const beforePartial = tail.slice(0, partialMatch.index).trim();
      if (beforePartial)
        segments.push({ type: 'text', content: beforePartial });
      if (partialMatch[2]) {
        segments.push({
          type: partialMatch[1].toLowerCase(),
          content: partialMatch[2],
        });
      }
    } else {
      const trimmedTail = tail.trim();
      if (trimmedTail && !OPENING_TAG_IN_PROGRESS_RE.test(trimmedTail)) {
        segments.push({ type: 'text', content: trimmedTail });
      }
    }
  } else {
    const trimmedTail = tail.trim();
    if (trimmedTail) segments.push({ type: 'text', content: trimmedTail });
  }

  if (segments.length === 0 && !isPartial)
    segments.push({ type: 'text', content: text });

  return segments;
}
